// The one loading screen.
//
// index.html paints an inline boot splash before any JS arrives. This
// component renders the SAME thing in React, so the handoff — inline
// splash → mounted app still fetching → content — reads as a single
// screen that never changes rather than a sequence of different loading
// states. If you edit one, edit the other: the markup in index.html and
// the markup here are deliberately twins.

export function AppLoading({ label = 'Loading your gym…' }: { label?: string }) {
  return (
    <div className="app-loading" role="status" aria-live="polite">
      <div className="app-loading-brand">
        <span className="app-loading-dot" />
        <span className="app-loading-word">Boulder Bash</span>
      </div>
      <div className="app-loading-track">
        <span className="app-loading-bar" />
      </div>
      <div className="app-loading-label">{label}</div>
    </div>
  );
}
